export interface UtagQueueFunction {
  /* eslint-disable */
  run: Function;
}

export interface UtagData {
  page_name: string;
  page_URL: string;
  event: string;
  event_data: string;
}

export interface UtagErrorData {
  event: string;
  page_URL: string;
  error_code: string;
  error_description: string;
  error_type: string;
}

export interface Utag {
  link(data: UtagData | UtagErrorData): void;
}

export enum AnalyticsErrorTypes {
  inline = 'Inline',
  api = 'api'
}
